import { Box, Button, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";

const CustomBackButton = ({ path, label }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      onClick={handleClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: label ? 1 : 0,
        px: 0,
        minWidth: "auto",
        textTransform: "none",
        color: "text.primary",
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          p: 0.5,
        }}
      >
        <ChevronLeftIcon sx={{ fontSize: 20 }} />
      </Box>

      {label && <Typography variant="body2">{label}</Typography>}
    </Button>
  );
};

export default CustomBackButton;
